import classNames from 'classnames';
import styles from './button.module.scss';

export enum RsButtonSize {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
  EXTRA_SMALL = 'extraSmall',
}

export const sizeMap = {
  [RsButtonSize.LARGE]: classNames(styles.size, styles.large),
  [RsButtonSize.MEDIUM]: classNames(styles.size, styles.medium),
  [RsButtonSize.SMALL]: classNames(styles.size, styles.small),
  [RsButtonSize.EXTRA_SMALL]: classNames(styles.size, styles['extra-small']),
};
